import { lazy } from "react"
import { RouteProps } from "../features.types"
const DashboardHome = lazy(() => import("./dashboard"))

const DashboardController = lazy(() => import("./dashboard-controller"))

// define route constant
export const DASHBOARD_ROUTE = "dashboard"

//define routes
export const Dashboard: RouteProps[] = [
  {
    path: DASHBOARD_ROUTE,
    Component: DashboardController,
    children: [
      {
        index: true,
        Component: DashboardHome,
      },
    ],
  },
]
